export default __webpack_public_path__ + "static/media/one.8fb3cd82.png";